"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChartContainer = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LineChartContainer = exports.LineChartContainer = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eqc7n110"
} : {
  target: "eqc7n110",
  label: "LineChartContainer"
})("width:", props => props.width && props.width, ";height:", props => props.height && props.height, ";");